import React, { useEffect, useMemo, useState } from "react";
import AssessmentEntry from "../../LearningTracking/AssessmentEntry";
import refreshIcon from '../../../../assests/admin/guide/refreshIcon.png'
import { submissionsApi } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import ExcelDownloadBtn from "./ExcelDownloadBtn";
import classes from './AssessmentsGuide.module.css'
import BackArrowTitle from "../../../UI/BackArrowTitle";


const AssessmentsGuide = ({ teacherId, teacherName, setShowSearch }) => {

    const [filteredlist, setFilteredlist] = useState(false)
    const { applicationId } = useSelector(state => state.application);
    const texts = useSelector(state => state.translate.texts);
    const titleRow = useMemo(() => { return { "studyGroup": texts.studyGroup, "assessmentName": texts.assessment, "submittedDate": texts.submissionDate, "score": texts.score } }, [texts])
    const dispatch = useDispatch();

    useEffect(() => {
        getRandomSubmissions(10)
    }, [teacherId])

    function getRandomSubmissions(limit) {

        let data = {
            limit: limit,
            applicationId: applicationId,
            teacherUserId: teacherId
        }

        submissionsApi.submissionsFilterRandomRangePost({ submissionsRandomInput: data }, (error, resdata, response) => {
            if (error) {
                if (error.status == 403)
                    dispatch(throwApiError({ userMessage: texts.errorNoPermission, error: error, statusCode: response?.statusCode, message: "errorNoPermission " + error.message, level: 2, component: "AssessmentsGuide", line: 141 }))
                else
                    dispatch(throwApiError({ userMessage: texts.submissionsRandomRangeFilterError, error: error, statusCode: response?.statusCode, message: "submissionsRandomRangeFilter " + error.message, level: 2, component: "AssessmentsGuide", line: 141 }))
            }
            else {
                if (response.body.length > 0) {
                    let newFilteredlist = [];
                    response.body.map(item =>
                        newFilteredlist.push({ studyGroup: item.studyGroupName, assessmentName: item.assessmentName, submittedDate: item.submittedDate, score: item.score, submissionStatusId: item.submissionStatusId, scoreAdditionalData: item.scoreAdditionalData, id: item.id })
                    )
                    setFilteredlist(newFilteredlist)
                }
                else
                    setFilteredlist([])
            }
        })
    }

    function refreshFunc() {
        getRandomSubmissions(10)
    }


    return (
        <>
            <div className={classes.Header}>
                <div className={classes.ChooseDetailsContainer}>
                    <BackArrowTitle text={teacherName} onClick={() => setShowSearch(true)}></BackArrowTitle>
                </div>
            </div>
            {filteredlist ?
                filteredlist.length > 0 ?
                    <>
                        <div className={classes.RefreshContainer}>
                            <img className={classes.RefreshIcon} src={refreshIcon} onClick={refreshFunc} alt="refreshIcon" />
                        </div>


                        <AssessmentEntry row={titleRow} title={true} fromAdmin={true} />
                        {(filteredlist && filteredlist.length > 0) && filteredlist.map((a, i) =>
                            <AssessmentEntry row={a} key={i} index={i} shortScoreCss={true} fromAdmin={true}></AssessmentEntry>)
                        }

                    </>
                    :
                    <p>{texts.noAssessmentFound}</p>
                : ''
            }
            <ExcelDownloadBtn teacherUserId={teacherId}></ExcelDownloadBtn>
        </>
    )
}

export default AssessmentsGuide;